import 'styles/application/modals/_subscription-commitment.scss';

import React from 'react';

import Button from 'components/Button';
import Modal from 'common/components/modals/Modal';
import propTypes from 'propTypes';
import CommitmentText from 'components/CommitmentText';
import { newMembership } from 'apps/account/paths';
import { TranslatedMessage } from 'common/components/Intl';

export default class SubscriptionCommitButton extends React.Component {
  state = {
    isOpen: false,
  };

  static propTypes = {
    canAddCommittableItem: propTypes.bool.isRequired,
    sku: propTypes.string.isRequired,
    handleAddToCartClick: propTypes.func.isRequired,
    hasCanceledSubscription: propTypes.bool,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  handleCommitting = () => {
    this.props.handleAddToCartClick(this.props.sku);
    this.closeModal();
  };

  renderKeyActionModal() {
    const { hasCanceledSubscription, isProcessing } = this.props;
    if (hasCanceledSubscription) {
      return (
        <Button.KeyAction
          className="SubscriptionCommitButton__modal__reactivate"
          element="a"
          href={newMembership()}
        >
          <TranslatedMessage
            id={'cart.subscription_commit_button.reactivate'}
          />
        </Button.KeyAction>
      );
    }
    return (
      <Button.KeyAction
        className="SubscriptionCommitButton__modal__confirm"
        processing={isProcessing}
        onClick={this.handleCommitting}
      >
        <TranslatedMessage id={'cart.subscription_commit_button.add_to_cart'} />
      </Button.KeyAction>
    );
  }

  renderModal = () => {
    const { isOpen } = this.state;
    return (
      <Modal
        className="SubscriptionCommitButton__modal"
        isOpen={isOpen}
        onRequestClose={this.closeModal}
      >
        <CommitmentText addToCart={true} {...this.props} />
        <div className="SubscriptionCommitButton__modal-button-container">
          <Button.Secondary
            onClick={this.closeModal}
            className="SubscriptionCommitButton__modal__dismiss"
          >
            <TranslatedMessage id={'cart.subscription_commit_button.decline'} />
          </Button.Secondary>
          {this.renderKeyActionModal()}
        </div>
      </Modal>
    );
  };

  render() {
    const { canAddCommittableItem } = this.props;
    return (
      <div>
        <Button.KeyAction
          onClick={this.openModal}
          disabled={!canAddCommittableItem}
          className="SubscriptionCommitButton"
        >
          <TranslatedMessage
            id={'cart.subscription_commit_button.get_it_with'}
          />{' '}
          <span className="nowrap">
            <TranslatedMessage
              id={'cart.subscription_commit_button.autoship'}
            />
          </span>
        </Button.KeyAction>
        {this.renderModal()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/SubscriptionCommitButton.js